import { useContext } from 'react';

import { context } from 'pages/ParentHelper/components/Chat/components/Body/components/Answer/components/FeedbackButtons/context';

export const useFeedbackButtonsContext = () => useContext(context);
